import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { fmtDateLong } from "@/lib/format";
import { fmtMinutes } from "@/lib/interventions";
import { BillingStatus, EconStatus, ReportStatus, fmtEur } from "@/lib/reports";

export const ReportRow = ({ rep, showCompany = true }) => (
  <li data-testid={`report-row-${rep.id}`}>
    <Link to={`/rapportini/${rep.id}`} className="flex flex-col gap-2 py-3 transition-colors hover:bg-slate-50/70 sm:flex-row sm:items-center sm:gap-4 sm:px-2">
      <div className="min-w-0 flex-1">
        <p className="font-mono text-xs font-semibold text-slate-400">{rep.number} · {rep.period ? `Mese ${rep.period}` : fmtDateLong(rep.report_date)}{rep.version > 1 ? ` · v${rep.version}` : ""}</p>
        <p className="truncate text-sm font-semibold text-ink">{showCompany ? rep.company_name : rep.intervention?.title}</p>
        <p className="truncate text-xs text-slate-500">{rep.intervention?.number} · {rep.technician_name || "—"}</p>
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-600">
        <span>Effettivo <b className="text-ink">{fmtMinutes(rep.effective_minutes)}</b></span>
        <span>Fatturabile <b className="text-ink">{rep.billable_minutes == null ? "—" : fmtMinutes(rep.billable_minutes)}</b></span>
        {rep.charge && <span data-testid={`report-row-taxable-${rep.id}`}>Imponibile <b className="text-ink">{fmtEur(rep.charge.taxable)}</b></span>}
        {rep.charge?.package_covered_net > 0 && <span>Pacchetto <b className="text-emerald-700">{fmtEur(rep.charge.package_covered_net)}</b></span>}
        {rep.charge && <span>Da fatturare <b className="text-ink">{fmtEur(rep.charge.to_invoice_net)}</b></span>}
        <ReportStatus status={rep.status} testId={`report-row-status-${rep.id}`} />
        <EconStatus status={rep.status === "confermato" || rep.status === "in_rettifica" ? rep.economic_status : null} />
        <BillingStatus rep={rep} testId={`report-row-billing-${rep.id}`} />
        <ChevronRight className="hidden h-4 w-4 text-slate-300 sm:block" />
      </div>
    </Link>
  </li>
);
